export const videos = [
  {
    id: 1,
    title: "Sibelius Violin Concerto, 1st mvmt.",
    youtubeId: "jDMHbY4AEXU", 
    description: "" //Add a description of the video here
  },
  {
    id: 2,
    title: "Bach Partita No. 3 in E Major, BWV 1006: Gavotte",
    youtubeId: "QzHFq8H6Bcw", 
    description: "" //Add a description of the video here
  },
  {
    id: 3,
    title: "Paganini Caprice No. 10",
    youtubeId: "_Tlgz8h0D64", 
    description: "" //Add a description of the video here
  }
];
